import Latex from "react-latex-next";
import {Video} from "./Video";
import {List} from "./List";
import React from "react";
import {PeriodicTable} from "./PeriodicTable";
import {TextContent} from "./TextContent";
import {HeaderContent} from "./HeaderContent";
import {TableContent} from "./TableContent";
import ImageContent from "./ImageContent";
import {ExampleContent} from "./ExampleContent";
import {IntegratedTest} from "./IntegratedTest";
import {QuoteContent} from "./QuoteContent";
import {CourseGoalsIntegrated} from "./CourseGoalsIntegrated";
import {IntegratedTerm} from "./IntegratedTerm";
import {BarGraph} from "../../components/graph/BarGraph";
import {LineGraph} from "../../components/graph/LineGraph";
import {Exam} from "./Exam";
import {CompositeTask} from "./CompositeTask";
import {OBS} from "../../components/OBS";
import {Columns} from "./Columns";
import {Comparison} from "./Comparison";
import {Subtask} from "./Subtask";
import {Algorithm} from "../../components/Algorithm";
import {AlgorithmStep} from "../../components/AlgorithmStep";
import {Container} from "./Container";

export default class ComplexParser {

    constructor(edit = false, content = [], setContent = null, terms=[], selectable=false, selectCallback = null, sortOrder = 1) {
        this.edit = edit;
        this.content = content;
        this.localContent = [...content];
        this.setContent = setContent;
        this.terms = terms;
        this.selectable = selectable;
        this.selectCallback = selectCallback;
        this.taskCount = 0;
        this.sortOrder = sortOrder;
        this.tableCount = 0;
        this.compareCount = 0;
    }

    parse() {

        const elements = [];
        this.tableCount = 0;

        for(let i = 0; i < this.localContent.length; i++) {

            let value = null;

            let json = this.localContent[i].value;
            value = this.decodeComplex(this.localContent[i]);
            elements.push(value);
        }

        return elements;
    }

    parseContent(content) {
        const elements = [];

        for(let i = 0; i < content.length; i++) {
            let value = this.decodeComplex(content[i]);
            elements.push(value);
        }

        return elements;
    }

    moveContent(index, direction) {
        if(index+direction <= 0 || index+direction < this.localContent.length) {
            let temp = structuredClone(this.localContent[index]);
            this.localContent[index] = this.localContent[index+direction];
            this.localContent[index].sortOrder = index;

            this.localContent[index+direction] = temp;
            this.localContent[index+direction].sortOrder = index+direction;

            this.updateContent();
        }
    }

    copyContent(index) {
        if (index <= 0 || index < this.localContent.length) {
            let copy = structuredClone(this.localContent[index]);
            this.localContent.push(copy);
            this.updateContent();
        }
    }

    deleteContent(index) {
        if (index <= 0 || index < this.localContent.length) {
            this.localContent.splice(index, 1);
            this.updateContent();
        }
    }

    updateContent() {
        this.setContent(this.localContent);
    }

    insertIntoContent(index, content) {
        switch (this.localContent[index].contentType) {
            default:
                this.localContent[index].value.value.push(content);
                break;
            case "EXAMPLE":
                this.localContent[index].value.push(content);
                break;
        }
        this.updateContent();

    }

    decodeComplex(json) {
        switch (json.contentType) {
            case "TABLE":
                this.tableCount += 1;
                return this.decodeTable(json);
            default:
            case "TEXT":
                return (<TextContent selectable={this.selectable} onClickCallback={() => this.selectCallback(json)} terms={this.terms} value={json.value} edit={this.edit} level={json.level} setContent={(content) => {
                    json.value = content;
                    this.updateContent();
                }}/>);
            case "HEADER":
                return (<HeaderContent value={json.value} level={0}  edit={this.edit} setContent={(content) => {
                    json.value = content;
                    this.updateContent();
                }}/>)
            case "HEADER_2":
                return (<HeaderContent value={json.value} level={1}  edit={this.edit} setContent={(content) => {
                json.value = content;
                this.updateContent();
            }}/>)
            case "HEADER_3":
                return (<HeaderContent value={json.value} level={2}  edit={this.edit} setContent={(content) => {
                    json.value = content;
                    this.updateContent();
                }}/>)
            case "LIST":
                return (<List  edit={this.edit} ordered={json.ordered} format={json.formatOptions}  toggleOrdered={() => {
                    json.ordered = !json.ordered;
                    this.updateContent();
                }}>{this.decodeList(json.value)}</List>)
            case "ROW":
                return this.decodeList(json.value)
            case "GENERIC":
                return <Container format={json.formatOptions}>{this.decodeList(json.value)}</Container>
            case "COLUMNS":
                return <Columns>{this.decodeList(json.value)}</Columns>
            case "COMPARE":
                this.compareCount++;
                return <Comparison index={this.compareCount}>{this.decodeList(json.value)}</Comparison>
            case "IMAGE":
                return (<ImageContent url={json.value.url} hash={json.value.hash} level={json.level} format={json.value.format} />)
            case "VIDEO":
                return (<Video video={json.value} key={json.checksum}></Video>)
            case "INTERACTIVE":
                return (<PeriodicTable/>)
            case "EXAMPLE":
                return (<ExampleContent>{json.value.map(item => this.decodeComplex(item))}</ExampleContent>);
            case "QUOTE":
                return (<QuoteContent>{json.value}</QuoteContent>);
            case "LATEX":
                if(json.display) {
                    return (
                        <h2 className={"text-center my-3"}>
                            <Latex>{json.value}</Latex>
                        </h2>
                    );
                }
                return (
                    <p><Latex>{json.value}</Latex></p>
                );
            case "TEST":
                return (<IntegratedTest>{json.value}</IntegratedTest>)
            case "QUIZ":
                return (<Exam test={json.value}></Exam>)
            case "GOAL":
                return (<CourseGoalsIntegrated courseGoals={json.value}></CourseGoalsIntegrated>)
            case "TERM":
                return (<IntegratedTerm term={json.value}></IntegratedTerm>)
            case "BAR_GRAPH":
                return (<BarGraph format={json.formatOptions} data={json.value} xIndex={"group"} keys={["Kovalent binding", "Polar kovalent binding", "Ionebinding"]}  horizontal={true} stacked={true} height={"35vh"}/> );
            case "LINE_GRAPH":
                return (<LineGraph data={json.value.lineData}
                                   xName={json.value.xaxisName}
                                   yName={json.value.yaxisName}
                                   xMin={json.value.xmin}
                                   xMax={json.value.xmax}
                                   yMin={json.value.ymin}
                                   yMax={json.value.ymax}
                                   funPointLabel={(item) => item.id}
                                   height={json.value.height}/> );
            case "TASK":
                this.taskCount++;
                return (<CompositeTask task={this.decodeComplex(json.value[0])} subtasks={this.decodeList(json.value.slice(1))} index={this.taskCount} />)
            case "SUBTASK":
                return (<Subtask id={json.checksum} content={this.decodeList(json.value)}/>)
            case "BREAK":
                const elements = [];
                for(let i = 0; i < json.value; i++) {
                    elements.push((<br></br>))
                }
                return elements;
            case "OBS":
                return <OBS>{json.value.map(item => this.decodeComplex(item))}</OBS>
            case "ALGORITHM":
                return <Algorithm title={"Algoritme"} steps={json.value.map((step, idx) => {
                    return (<AlgorithmStep index={idx+1} children={this.decodeList(step.value)}/>)
                })}/>

    }


        return null;
    }


    decodeList(list) {
        const children = [];
        if(list != null) {
            for(let i = 0; i < list.length; i++) {
                children.push(this.decodeComplex(list[i]));
            }
        }

        return children;
    }

    decodeTable(json) {
        const table = json.value;
        const rows = [];
        const headers = [];

        for(let i = 0; i < table.length; i++) {
            if(table[i].contentType === "TABLE_HEADER") {

                headers.push((<tr key={"tr-"+i}>
                    {
                        table[i].value.map(cell => (
                            <>
                                {

                                        <th key={"th-"+i} scope={"col"} className={"p-3"}>
                                            {this.decodeComplex(cell)}
                                        </th>

                                }
                            </>
                        ))
                    }
                </tr>));
            } else {
                rows.push((<tr key={"tr-"+i}>
                    {
                        table[i].value.map(cell => (
                            <>

                                    <td key={"td-"+i} className={"p-3"}>
                                        {this.decodeComplex(cell)}
                                    </td>

                            </>
                        ))
                    }
                </tr>));
            }
        }
        return (<TableContent classes={"table-dark"} format={json.formatOptions} headers={headers} chapterIndex={this.sortOrder} tableIndex={this.tableCount}>{rows}</TableContent>);
    }



}